import React from "react";
import ContactUsSection from "../Home/ContactUsSection.jsx";

const ContactPage = () => <ContactUsSection />;

export default ContactPage;
